<template>
    <section>
        <b-overlay :show="loading" no-wrap opacity="1">
        </b-overlay>
        <section class="filterContainer">
            <b-input type="text" v-model="filterListText" placeholder="Filtrar indicadores" />
            <searchDatePicker :lang="ptbr" :shortcuts="shortcuts" v-model="customInterval" class="custom-date"
                type="datetime" format="DD/MM/YYYY HH:mm:ss" range placeholder="Intervalo da busca"
                range-separator="  até  ">
                <template v-slot:input="slotProps">
                    <input type="text" class="inputDateIdList" v-bind="slotProps.props" v-on="slotProps.events" />
                </template>

                <template v-slot:icon-calendar>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                        <path
                            d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
                    </svg>
                </template>
            </searchDatePicker>
            <button @click="openHistGraph(selectedInd, selectedIndIdx)">
                <b-icon-search></b-icon-search>
                <span>Filtrar</span>
            </button>
        </section>
        <section class="graphTrendContainer" v-if="showHist != null">
            <apexcharts v-if="chartOptions.meanChart" :options="chartOptions.meanChart" height="230px"
                :series="chartOptions.meanChart && chartOptions.meanChart.series != undefined ? chartOptions.meanChart.series : []">
            </apexcharts>
            <apexcharts v-if="chartOptions.ppkChart" :options="chartOptions.ppkChart" height="230px"
                :series="chartOptions.ppkChart && chartOptions.ppkChart.series != undefined ? chartOptions.ppkChart.series : []">
            </apexcharts>
            <apexcharts v-if="chartOptions.reabilityChart" :options="chartOptions.reabilityChart" height="230px"
                :series="chartOptions.reabilityChart && chartOptions.reabilityChart.series != undefined ? chartOptions.reabilityChart.series : []">
            </apexcharts>
            <apexcharts v-if="chartOptions.trendChart" :options="chartOptions.trendChart" height="230px"
                :series="chartOptions.trendChart && chartOptions.trendChart.series != undefined ? chartOptions.trendChart.series : []">
            </apexcharts>
        </section>
        <div class="indicatorsHeader">
            <p>Indicador</p>
            <div>
                <p>Qtde. RTAs/FCAs</p>
                <p>Valor Real</p>
                <p>Valor Previsto</p>
            </div>
            <p></p>
        </div>
        <section class="listIndicatorsContainer">
            <ManagementIndicators v-for="(ind, idx) in filterIndicators()" :key="'indList-' + idx" :indicators="ind"
                :mainIdx="idx" innerBtnLabel="Ver Histórico" :showRemoveBtn="false" :openDetailsFunc="openHistGraph"
                :showIndVal="true">
                <template #button>
                    <section class="indBtnGroup">
                        <b-button class="showTriggerBtn" @click="showTriggersModal(ind)">
                            <b-icon-list-task />
                            <span>Ver Gatilhos</span>
                        </b-button>

                        <b-button v-if="showHist == null || showHist != idx" class="showHistBtn"
                            @click="openHistGraph(ind.MainIndicatorId, idx)">
                            <b-icon-graph-up />
                            <span>Ver Histórico</span>
                        </b-button>

                        <b-button v-if="showHist == idx" class="hideHistBtn" @click="closeHistGraph()">
                            <b-icon-graph-up />
                            <span>Ocultar Histórico</span>
                        </b-button>
                    </section>
                </template>
            </ManagementIndicators>
        </section>

        <b-modal id="triggersInfoModal" title="Gatilhos Configurados" hide-footer>
            <section v-if="triggersToShow.length > 0">
                <p class="shootIntervalHint">Disparos filtrados pelo intervalo da busca.</p>
                <section v-for="(trigger, trigIdx) in triggersToShow" :key="'trig-' + trigIdx"
                    class="triggerShowContent">
                    <p><strong>Gatilho:</strong> {{ trigger.TriggerCode }}</p>
                    <v-chart v-if="trigger.TriggersShoot && trigger.TriggersShoot.length > 0"
                        :option="getChartOptions(chartShoots(trigger.TriggersShoot))" :theme="defaultTheme"
                        style="height: 150px; width: 30rem;" />
                    <p v-else class="noShootMsg">Nenhum disparo no período selecionado.</p>
                </section>
            </section>
            <p v-else>Nenhum gatilho configurado!</p>
        </b-modal>
    </section>
</template>

<script>
import ManagementIndicators from './commons/ManagementIndicators.vue';
import { meanChart, ppkChart, reabilityChart, trendChart } from '../manageAllOccurrences/utils/ChartOptions';
import VueApexCharts from "vue-apexcharts";
import axios from 'axios';
import { urlMainAPI, showError } from '../../global.js';
import searchDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ptbr from 'vue2-datepicker/locale/pt-br';
import { mapState } from "vuex";
import * as moment from 'moment';
import VChart from "vue-echarts";
import * as echarts from 'echarts';
import "echarts";
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import CustomTheme from './commons/graphTheme.json'
export default {
    name: "ListIndicatorsRTA",
    components: { ManagementIndicators, apexcharts: VueApexCharts, searchDatePicker, VChart },
    data() {
        return {
            loading: false,
            indicatorsData: [],
            showHist: null,
            chartOptions: {},
            filterListText: "",
            ptbr: {
                ...ptbr,
                monthFormat: 'MMMM'
            },
            customInterval: [moment().format("YYYY-MM-DDT00:00:00-03:00"), moment().format("YYYY-MM-DDT23:59:59-03:00")],
            shortcuts: [
                {
                    text: 'Hoje',
                    onClick: () => {
                        let today = new Date()
                        this.customInterval = [new Date(today.setHours(0, 0, 0, 0)), new Date(today.setHours(23, 59, 59, 999))];
                    }
                },
                {
                    text: '2 dias',
                    onClick: () => {
                        let two = new Date();
                        two.setDate(two.getDate() - 1)
                        this.customInterval = [two, new Date()];
                    }
                },
                {
                    text: '3 dias',
                    onClick: () => {
                        let three = new Date();
                        three.setDate(three.getDate() - 2)
                        this.customInterval = [three, new Date()];
                    }
                },
                {
                    text: '5 dias',
                    onClick: () => {
                        let five = new Date();
                        five.setDate(five.getDate() - 4)
                        this.customInterval = [five, new Date()];
                    }
                },
                {
                    text: '7 dias',
                    onClick: () => {
                        let seven = new Date();
                        seven.setDate(seven.getDate() - 6)
                        this.customInterval = [seven, new Date()];
                    }
                },
                {
                    text: '15 dias',
                    onClick: () => {
                        let fifteen = new Date();
                        fifteen.setDate(fifteen.getDate() - 14)
                        this.customInterval = [fifteen, new Date()];
                    }
                }
            ],

            selectedInd: null,
            selectedIndIdx: null,
            triggersToShow: [],
            defaultTheme: 'customTheme'
        }
    },
    computed: mapState(["user"]),

    methods: {
        filterIndicators() {
            return this.filterListText != '' && this.filterListText != undefined ?
                this.indicatorsData.filter(item => item.MainIndicatorName.toLowerCase().includes(this.filterListText.toLowerCase()) ||
                    item.OperationalInds.filter(op => op.IndicatorName.toLowerCase().includes(this.filterListText.toLowerCase())).length > 0) : this.indicatorsData;
        },

        async resetFilters() {
            await this.loadIndicatorsRelated(this.defaultFilters);
        },

        async openHistGraph(id, idx = 0) {
            // Sem indicador selecionado (ex.: "Filtrar" clicado antes de abrir um histórico)
            // nao ha grafico para refiltrar.
            if (id == null) {
                showError("Selecione um indicador (Ver Histórico) antes de filtrar.");
                return;
            }

            if (typeof id != "number") {
                this.selectedInd = id.IndicatorId;
            } else {
                this.selectedInd = id;
            }
            this.selectedIndIdx = idx;

            let objToSend = {
                key: `KP0${this.user.UnitId}000${this.selectedInd}`,
                initialTimestamp: moment(this.customInterval[0]).format("YYYY-MM-DDTHH:mm:ss-03:00"),
                finalTimestamp: moment(this.customInterval[1]).format("YYYY-MM-DDTHH:mm:ss-03:00"),
                filterFlag: 0,
                filterValue: 0,
                agregation: "ON",
            }

            this.loading = true;

            await axios.post(`${urlMainAPI}/getindicatortrend`, objToSend)
                .then(res => {
                    this.chartOptions.meanChart.series = res.data.meanChart.series;
                    this.chartOptions.ppkChart.series = res.data.ppkChart.series;
                    this.chartOptions.reabilityChart.series = res.data.reabilityChart.series;
                    this.chartOptions.trendChart.series = res.data.trend.series;
                })
                .catch(err => console.error(err))

            this.showHist = idx;
            this.loading = false;
        },

        closeHistGraph() {
            this.showHist = null;
        },

        async loadIndicatorsRelated() {
            await axios.get(`${urlMainAPI}/getRTAIndicatorsRelated`)
                .then(res => {
                    this.indicatorsData = res.data;
                }).catch(err => {
                    console.error(err)
                });
        },

        // Carrega os disparos de um indicador sob demanda, filtrados pelo intervalo da busca.
        // force = false: se o volume passar do limite, o backend devolve so a contagem
        // (NeedsConfirmation) sem puxar os dados pesados.
        async fetchTriggerShoots(indicatorId, force) {
            const params = { indicatorId, force };
            if (this.customInterval && this.customInterval[0] && this.customInterval[1]) {
                params.startDate = moment(this.customInterval[0]).format("YYYY-MM-DDTHH:mm:ss-03:00");
                params.endDate = moment(this.customInterval[1]).format("YYYY-MM-DDTHH:mm:ss-03:00");
            }

            this.loading = true;
            try {
                const res = await axios.get(`${urlMainAPI}/getRTAIndicatorTriggerShoots`, { params });
                return res.data;
            } catch (err) {
                console.error(err);
                return null;
            } finally {
                this.loading = false;
            }
        },

        async showTriggersModal(ind) {
            const result = await this.fetchTriggerShoots(ind.MainIndicatorId, false);
            if (!result) return;

            if (result.NeedsConfirmation) {
                const confirmed = await this.$bvModal.msgBoxConfirm(
                    `Este indicador tem ${result.Total} disparos no período selecionado. O carregamento pode demorar um pouco. Deseja continuar?`,
                    {
                        title: "Muitos disparos no período",
                        okTitle: "Continuar",
                        cancelTitle: "Cancelar",
                        okVariant: "warning",
                        centered: true
                    }
                );
                if (!confirmed) return;

                const full = await this.fetchTriggerShoots(ind.MainIndicatorId, true);
                if (!full) return;
                this.triggersToShow = full.Triggers || [];
            } else {
                this.triggersToShow = result.Triggers || [];
            }

            this.$bvModal.show("triggersInfoModal");
        },

        // Os disparos chegam do backend ja filtrados pelo intervalo e ordenados do mais
        // recente para o mais antigo. Inverte para ordem cronologica no grafico.
        chartShoots(triggerShootList) {
            return [...triggerShootList].reverse();
        },

        getChartOptions(triggerShootList) {
            return {
                tooltip: { trigger: "axis" },
                legend: {
                    bottom: 10, // Aumenta o espaçamento entre a legenda e o eixo X
                    data: ["Real", "Previsto"],
                    textStyle: { fontSize: 10 },
                    itemWidth: 8,
                    itemHeight: 8,
                },
                grid: {
                    top: 10,
                    bottom: 50, // Ajustado para dar mais espaço para a legenda
                    left: 40,
                    right: 20
                },
                xAxis: {
                    type: "category",
                    data: triggerShootList.map(shoot => new Date(shoot.shootingDate).toLocaleDateString()),
                    axisLabel: { fontSize: 10, interval: 0 },
                },
                yAxis: { type: "value" },
                series: [
                    {
                        name: "Real",
                        type: "line",
                        data: triggerShootList.map(shoot => shoot.value),
                        smooth: true,
                        label: { show: true, fontSize: 10 },
                    },
                    {
                        name: "Previsto",
                        type: "line",
                        data: triggerShootList.map(shoot => shoot.target),
                        smooth: true,
                        label: { show: true, fontSize: 10 },
                    }
                ],
            };
        },
    },

    async mounted() {
        this.loading = true;
        await this.loadIndicatorsRelated(this.defaultFilters);

        this.filteredData = this.indicatorsData;

        this.loading = false;
    },

    created() {
        this.chartOptions = {
            meanChart: meanChart,
            ppkChart: ppkChart,
            reabilityChart: reabilityChart,
            trendChart: trendChart
        };

        this.chartOptions.meanChart.chart.toolbar = { show: false }
        this.chartOptions.ppkChart.chart.toolbar = { show: false }
        this.chartOptions.reabilityChart.chart.toolbar = { show: false }

        echarts.registerTheme('customTheme', CustomTheme);
    },
}
</script>

<style scoped>
.shootIntervalHint {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 1rem;
}

.noShootMsg {
    font-size: 0.8rem;
    color: #888;
    font-style: italic;
}

.indicatorsHeader {
    background-color: black;
    color: #fff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    font-size: 0.8rem;
}

.indicatorsHeader div {
    display: flex;
    align-items: center;
    column-gap: 2rem;
    margin-left: 8rem;
}

.indicatorsHeader p {
    margin: 0;
    padding: 0;
}

.indBtnGroup {
    display: flex;
    column-gap: 0.3rem;
    align-items: center;
}

.showTriggerBtn,
.showHistBtn,
.hideHistBtn {
    padding: 0.2rem 0.8rem;
    border: 1px solid;
    border-radius: 0.3rem;
    font-weight: 600;

    display: flex;
    column-gap: 0.3rem;
    align-items: center;
}

.showTriggerBtn {
    background-color: #FF71223D;
    border-color: transparent;
    color: #FF7122;
}

.showHistBtn {
    background-color: #FF7122;
    color: #fff;
}

.hideHistBtn {
    background-color: #fff;
    color: #FF7122;
    border-color: #FF7122;
}

.graphTrendContainer {
    width: 100%;
    display: grid;
    grid-template-columns: 1.05fr 1fr 1fr 5.05fr;
}

.filterContainer {
    margin: 0.8rem 0;
    display: flex;
    column-gap: 0.5rem;
}

.filterContainer input,
.filterContainer select {
    max-width: 15rem;
    width: 15rem;
}

.filterContainer .custom-date {
    border: 1px solid #ff5f00;
    border-radius: 3px;
    width: 23rem;
}

.filterContainer .custom-date i>svg {
    fill: #ff5f00;
}

.filterContainer .custom-date input {
    border: none !important;
    width: 100% !important;
    max-width: 100% !important;
}

.filterContainer .custom-date input:focus {
    box-shadow: none !important;
}

.filterContainer button {
    background-color: #ff5f00;
    color: #fff;
    padding: 0.3rem 0.5rem;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    font-weight: 600;
}

.filterContainer .reset {
    background-color: #fff;
    color: #ff5f00;
}
</style>